import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';

export type HomeBuyerVoice = {
  quote: string;
  author: string;
  location: string;
};

const AVATAR_GRADIENTS = [
  'from-[#3B3B98] to-[#9B59B6]',
  'from-violet-600 to-fuchsia-500',
  'from-indigo-600 to-purple-500',
] as const;

function authorInitial(name: string): string {
  const trimmed = name.trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?';
}

type HomeBuyerVoiceCardProps = Readonly<{
  voice: HomeBuyerVoice;
  index: number;
}>;

export function HomeBuyerVoiceCard({ voice, index }: HomeBuyerVoiceCardProps) {
  const initial = authorInitial(voice.author);
  const gradient = AVATAR_GRADIENTS[index % AVATAR_GRADIENTS.length];

  return (
    <article className="home-proof-card rounded-2xl border border-white/10 bg-white/[0.05] p-3.5 transition-colors hover:border-white/20 hover:bg-white/[0.08]">
      <div className="flex items-center gap-2.5">
        <span
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br text-sm font-extrabold text-white ring-1 ring-white/20 ${gradient}`}
          aria-hidden
        >
          {initial}
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold text-white">{voice.author}</p>
          <p className="truncate text-[10px] font-semibold uppercase tracking-wide text-white/50">
            {voice.location}
          </p>
        </div>
        <div className="flex shrink-0 gap-px" aria-label="5 star review">
          {Array.from({ length: 5 }, (_, i) => (
            <StarIconSolid
              key={`${voice.author}-star-${i}`}
              className="h-2.5 w-2.5 text-amber-300"
            />
          ))}
        </div>
      </div>
      <blockquote className="mt-2.5 line-clamp-2 text-[13px] leading-snug text-white/80 md:line-clamp-3">
        &ldquo;{voice.quote}&rdquo;
      </blockquote>
    </article>
  );
}
